<template>
  <v-container fluid mb-12 mt-5 style="width: 90%">
    <v-row>
      <v-col sm="3" md="6" offset-lg="0">
        <h1>Record Fillings</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <hr />
    <div class="v-row">
      <RecordsViewModule :viewMode="viewMode" :search="search" />
      <RecordsViewList
        :viewMode="viewMode"
        :search="search"
        :routeAccess="false"
        :isFetching="isFetching"
      />
      <v-row>
        <v-col cols="12 text-right pr-6">
          <v-btn small fab depressed class="mr-4">
            <v-icon color="indigo" @click="setViewMode('list')"
              >mdi-view-list</v-icon
            >
          </v-btn>
          <v-btn small fab depressed>
            <v-icon color="indigo" @click="setViewMode('module')"
              >mdi-view-module</v-icon
            >
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <!-- <v-row>
      <v-col offset="1" cols="10">
        <v-row>
          <v-col sm="5" md="6" offset-lg="0">
            <h1>Record Filings</h1>
            <v-spacer></v-spacer>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <hr />
        <RecordsViewModule :viewMode="viewMode" :search="search" />
        <RecordsViewList
          :viewMode="viewMode"
          :search="search"
          :routeAccess="false"
          :isFetching="isFetching"
        />
        <v-row>
          <v-col cols="12 text-right pr-6">
            <v-btn small fab depressed class="mr-4">
              <v-icon color="indigo" @click="setViewMode('list')"
                >mdi-view-list</v-icon
              >
            </v-btn>
            <v-btn small fab depressed>
              <v-icon color="indigo" @click="setViewMode('module')"
                >mdi-view-module</v-icon
              >
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RecordsViewModule from "../../components/records/RecordsViewModule";
import RecordsViewList from "../../components/records/RecordsViewList";

export default {
  name: "RecordFilings",
  components: {
    RecordsViewModule,
    RecordsViewList,
  },
  data() {
    return {
      isFetching: false,
      singleSelect: false,
      selected: [],
      search: "",
      errorMessage: null,
      nextPath: "/records/filings/",
      security_level_items: ["Low", "Moderate", "High"],
      dialog: false,
      editedIndex: -1,
      security_level: "",
      editedItem: {
        title: "",
        name: "",
        description: "",
        security_level: "Low",
      },
      defaultItem: {
        title: "",
        name: "",
        security_level: "Low",
      },
      viewMode: "list",
    };
  },
  methods: {
    ...mapActions([
      "fetchRecordFilings",
      "updateRecordFiling",
      "deleteRecordFiling",
      "fetchUnsortedFiles",
    ]),
    getStatusColor(status) {
      if (status === true) return "green";
      else return "red";
    },
    setViewMode(mode) {
      this.viewMode = mode;
    },
  },
  computed: {
    ...mapGetters(["allRecordFilings", "allUnsortedRecords"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  created() {
    if(this.allUnsortedRecords.length == 0)
      this.isFetching = true
    this.fetchRecordFilings().then(()=> {
      this.isFetching = false
    });
    this.fetchUnsortedFiles();
  },
};
</script>

<style>
</style>